import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-animated-image',
	templateUrl:'./WaAnimatedImagePage.html',
	styles: [],
	styleUrls:['./WaAnimatedImagePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaAnimatedImagePage
{
	mdContent_272 = `\`\`\`java
import com.jwebmp.webawesome.components.animatedimage.WaAnimatedImage;
\`\`\``;
}
